/**
 * Material Calc does not support drawing of radius lines based on 3 points
 * In order to support Markup Pdf Drawing, Digitizer provides to MC multiple points to
 * represent radius line
 */
export const NUM_OF_POINTS_FOR_RADIUS_LINES = 20
